// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/
:host ::ng-deep ngb-modal-window.fade {
  opacity: 1 !important;
}

.cald_full-container {
  height: 100%;
}

.cald-app-container {
  position: absolute;
  height: calc(100% - 5.2rem);
  width: 100%;
  overflow: hidden;
  padding: 0rem;
}
.cald-app-container .cald-side-module-container {
  height: 100%;
  overflow: auto;
}
.cald-app-container .cald-module-container {
  height: 100%;
  overflow: auto;
  padding: 0rem;
  background-color: #fff;
  display: flex;
}

.global-side-panel {
  height: 100%;
  width: 4.8rem;
  z-index: 100;
  overflow: hidden;
  cursor: pointer;
  position: absolute;
  box-shadow: 1px 0 1px 0 rgba(229, 229, 229, 0.5);
}
.global-side-panel .global-side-panel-content {
  width: 24rem;
  overflow: hidden;
}

.global-side-panel-expand {
  width: 24rem;
}

.global-route-container {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  width: calc(100% - 4.8rem);
  padding: 0rem;
  margin-left: 4.8rem;
}

.global-route-container-width {
  width: 100% !important;
}

.global-route-container-expand {
  margin-left: 24rem;
}

@media (max-width: 768px) {
  .slider-cald {
    width: 90% !important;
  }
}
.slider-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  top: 4.8rem;
  width: 100%;
  z-index: 1;
  background-color: rgba(255, 255, 255, 0.6);
  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.6);
}

.slider-cald {
  background-color: #ffffff;
  box-shadow: -0.2rem 0.1rem 0.2rem 0 rgba(0, 0, 0, 0.15);
  top: 4.8rem;
  bottom: 0;
  position: fixed;
  right: 0;
  width: 49rem;
}`, "",{"version":3,"sources":["webpack://./src/app/assets/css/fonts.scss","webpack://./src/app/app.component.scss"],"names":[],"mappings":"AAIA,gHAAA;ACHA;EACE,qBAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,kBAAA;EAEA,2BAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;AAAF;AACE;EACE,YAAA;EACA,cAAA;AACJ;AACE;EACE,YAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AACJ;;AAGA;EACE,YAAA;EACA,aAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;EACA,kBAAA;EACA,gDAAA;AAAF;AACE;EACE,YAAA;EACA,gBAAA;AACJ;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,aAAA;EACA,mBAAA;AAAF;;AAGA;EACE,sBAAA;AAAF;;AAGA;EACE,kBAAA;AAAF;;AAGA;EACE;IACE,qBAAA;EAAF;AACF;AAGA;EACE,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,UAAA;EACA,0CAAA;EACA,wCAAA;AADF;;AAGA;EACE,yBAAA;EACA,uDAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,QAAA;EACA,YAAA;AAAF","sourcesContent":["%font-black{\n    font-family: '72-Black';\n}\n\n/*As per SAP UX Standards, In entire application there should not be bold text. So, commenting this font Styles*/\n// %font-bold{\n//     font-family: '72-Bold';\n// }\n\n// %font-condensed-bold{\n//     font-family: '72-CondensedBold';\n// }\n\n// %font-bold-italic{\n//     font-family: '72-BoldItalic';\n// }\n\n%font-condensed{\n    font-family: '72-Condensed';\n}\n\n%font-italic{\n    font-family: '72-Italic';\n}\n\n%font-regular{\n    font-family: '72-Regular';\n}\n\n%font-light{\n    font-family: '72-Light';\n}\n\n@import '_variables';","@import './assets/css/fonts';\n:host ::ng-deep ngb-modal-window.fade {\n  opacity: 1 !important;\n}\n\n.cald_full-container {\n  height: 100%;\n}\n\n.cald-app-container {\n  position: absolute;\n  //top: 5.3rem;\n  height: calc(100% - 5.2rem);\n  width: 100%;\n  overflow: hidden;\n  padding: 0rem;\n  .cald-side-module-container {\n    height: 100%;\n    overflow: auto;\n  }\n  .cald-module-container {\n    height: 100%;\n    overflow: auto;\n    padding: 0rem;\n    background-color: #fff;\n    display: flex;\n  }\n}\n\n.global-side-panel {\n  height: 100%;\n  width: 4.8rem;\n  z-index: 100;\n  overflow: hidden;\n  cursor: pointer;\n  position: absolute;\n  box-shadow: 1px 0 1px 0 rgba(229, 229, 229, 0.5);\n  .global-side-panel-content {\n    width: 24rem;\n    overflow: hidden;\n  }\n}\n\n.global-side-panel-expand {\n  width: 24rem;\n}\n\n.global-route-container {\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  width: calc(100% - 4.8rem);\n  padding: 0rem;\n  margin-left: 4.8rem;\n}\n\n.global-route-container-width{\n  width: 100% !important;\n}\n\n.global-route-container-expand {\n  margin-left: 24rem;\n}\n\n@media (max-width: 768px) {\n  .slider-cald {\n    width: 90% !important;\n  }\n}\n\n.slider-overlay{\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  top: 4.8rem;\n  width: 100%;\n  z-index: 1;\n  background-color: rgba(255,255,255, 0.6);\n  box-shadow: 0 3px 5px rgba(0, 0, 0, 0.6);\n}\n.slider-cald {\n  background-color: #ffffff;\n  box-shadow: -0.2rem 0.1rem 0.2rem 0 rgba(0, 0, 0, 0.15);\n  top:4.8rem;\n  bottom: 0;\n  position: fixed;\n  right:0;\n  width: 49rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
